import { DPEmployeeDisbursement } from "Shared/types/Disbursements";
import dayjs from "dayjs";

export const checkDuplicateDisbursements = (
  disbursements: DPEmployeeDisbursement[] | undefined,
  paymentAmount: number
) => {
  if (disbursements === undefined) {
    return false;
  }

  const oneDayAgo = dayjs().subtract(24, "hour");

  return disbursements.some(disbursement => {
    return (
      disbursement.totalAmountCents === paymentAmount &&
      dayjs(disbursement.createdAt) > oneDayAgo
    );
  });
};
